import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';
import NotFound from "pages/NotFound";
import ProjectsGallery from './pages/projects-gallery';
import SmartContact from './pages/smart-contact';
import AdminDashboard from './pages/admin-dashboard';
import LoginPage from './pages/login';
import CustomerPortal from './pages/customer-portal';
import ECommerceStore from './pages/e-commerce-store';
import ResourcesHub from './pages/resources-hub';
import Homepage from './pages/homepage';
import ServiceDetails from './pages/service-details';
import AboutUs from './pages/about-us';
import ServicesPage from './pages/services';
import PaymentCheckout from './pages/payment-checkout';
import PaymentStatusTracking from './pages/payment-status-tracking';

// Analytics wrapper component
const AnalyticsWrapper = ({ children }) => {
  useGoogleAnalytics();
  return children;
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AnalyticsWrapper>
          <ScrollToTop />
          <RouterRoutes>
            {/* Define your route here */}
            <Route path="/" element={<Homepage />} />
            <Route path="/homepage" element={<Homepage />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/smart-contact" element={<SmartContact />} />
            <Route path="/service-details" element={<ServiceDetails />} />
            <Route path="/service-details/:serviceType" element={<ServiceDetails />} />
            <Route path="/projects-gallery" element={<ProjectsGallery />} />
            <Route path="/resources-hub" element={<ResourcesHub />} />
            <Route path="/e-commerce-store" element={<ECommerceStore />} />
            <Route path="/customer-portal" element={<CustomerPortal />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/payment-checkout" element={<PaymentCheckout />} />
            <Route path="/payment-status-tracking" element={<PaymentStatusTracking />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </AnalyticsWrapper>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;